export const vividGreen = {
  50: '#03110B',
  100: '#072718',
  200: '#0F5233',
  300: '#167E4D',
  400: '#1FAD6B',
  500: '#26D985',
  600: '#5AE2A3',
  700: '#8AEABD',
  800: '#B1F1D3',
  900: '#CFF7E4',
  950: '#E5FAF0',
  990: '#F6FDFA',
};

export const vividPurple = {
  50: '#090A1B',
  100: '#0F1033',
  200: '#111345',
  300: '#2A2D92',
  400: '#2A2D92',
  500: '#3339DB',
  600: '#4C51EB',
  700: '#A8AAF5',
  800: '#A8AAF5',
  900: '#CDCFF9',
  950: '#E8E9FC',
  990: '#F6F6FE',
};

export const darkNavy = {
  30: '#05070A',
  50: '#090B10',
  70: '#0C0F17',
  100: '#121621',
  110: '#12182B',
  130: '#171C2B',
  150: '#1B2132',
  180: '#20273C',
  200: '#242B42',
  300: '#364163',
  400: '#475785',
  500: '#596CA6',
  600: '#7A87B8',
  700: '#9CA7C9',
  800: '#BDC4DB',
  900: '#DEE1ED',
  910: '#E1E5EF',
  920: '#E5E8F1',
  940: '#ECEEF3',
  960: '#F1F3F8',
  980: '#F9F9FB',
  990: '#FBFCFD',
};

export const grayNavy = {
  50: '#0C0C0D',
  70: '#0F1014',
  100: '#16161D',
  200: '#1C1C24',
  300: '#21222B',
  400: '#272833',
  500: '#323443',
  600: '#434456',
  700: '#5E617D',
  800: '#999BB2',
  900: '#B8B9C6',
  920: '#D4D6DD',
  950: '#E0E2E5',
  970: '#ECEDEE',
  990: '#F7F7F8',
};

export const blue = {
  50: '#031017',
  100: '#05202E',
  200: '#0A415C',
  300: '#0F628A',
  400: '#1482B8',
  500: '#1AA1E5',
  600: '#47B5EB',
  700: '#75C7F0',
  800: '#A3DAF5',
  900: '#D1EDFA',
  950: '#E8F6FC',
  990: '#F6FBFE',
};

export const red = {
  50: '#160404',
  100: '#2B0809',
  200: '#5B1A1D',
  300: '#82171B',
  400: '#AD1F23',
  500: '#D9262C',
  600: '#E05256',
  700: '#E87D81',
  800: '#F0A8AB',
  900: '#F7D4D5',
  950: '#FBE9EA',
  990: '#FDF6F7',
};

export const yellow = {
  50: '#0F0F00',
  100: '#2D2B01',
  200: '#413D0B',
  300: '#827817',
  400: '#CBB106',
  500: '#F7CF08',
  600: '#F9D648',
  700: '#FBE179',
  800: '#FCEAA1',
  900: '#FDF4CE',
  950: '#FEF9E6',
  990: '#FFFDF5',
};

export const orange = {
  50: '#364163',
  100: '#2E1705',
  200: '#5C2E0A',
  300: '#8A440F',
  400: '#C05A0C',
  500: '#F37617',
  600: '#F58D3D',
  700: '#FFA866',
  800: '#FFC699',
  900: '#FBE0CB',
  950: '#FCF1E8',
  990: '#FEF9F6',
};

export const purple = {
  50: '#10031C',
  100: '#1B052E',
  200: '#36095D',
  300: '#510E8B',
  400: '#6C12BA',
  500: '#8617E8',
  600: '#9F45ED',
  700: '#B774F1',
  800: '#D1A7F6',
  900: '#E7D1FA',
  950: '#F3E8FD',
  990: '#FAF6FE',
};

export const green = {
  50: '#0B1703',
  100: '#15300D',
  200: '#1A450C',
  300: '#2C8112',
  400: '#37A216',
  500: '#41BA1C',
  600: '#54DF2A',
  700: '#7ADA5D',
  800: '#9DEA86',
  900: '#C2F5B3',
  950: '#DCF8D3',
  990: '#EAFBE4',
};

export const common = {
  black: '#000',
  white: '#fff',
};

const colorPalette = {
  vividGreen,
  vividPurple,
  darkNavy,
  grayNavy,
  blue,
  red,
  yellow,
  common,
  orange,
  purple,
  green,
};

export default colorPalette;